/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Faq_A8Inputs */

const en_home_faq_a8 = /** @type {(inputs: Home_Faq_A8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the Download page and pick your platform. Windows uses an MSI installer, macOS a universal DMG and Linux a Flatpak or AppImage. You can also install CADCraft through the ArtCraft Launcher, which keeps it up to date.`)
};

/**
* | output |
* | --- |
* | "Open the Download page and pick your platform. Windows uses an MSI installer, macOS a universal DMG and Linux a Flatpak or AppImage. You can also install CAD..." |
*
* @param {Home_Faq_A8Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_faq_a8 = /** @type {((inputs?: Home_Faq_A8Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Faq_A8Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_faq_a8(inputs)
});
export { home_faq_a8 as "home.faq.a8" }